import { Suspense, useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useHits } from "react-instantsearch";

const SearchResults = ({
  title,
  showDetails,
  WrappedComponent,
  shouldTrackAlgoliaAnalytics = false,
  skeletonSlot,
  isLoading,
  isIdle,
  ...props
}) => {
  const [showSkeleton, setShowSkeleton] = useState(true);
  const [searchStarted, setSearchStarted] = useState(false);

  const transformItems = useCallback(
    (items) => {
      return items?.map((item) => ({
        ...item,
        shouldTrackAlgoliaAnalytics,
      }));
    },
    [shouldTrackAlgoliaAnalytics],
  );

  const { items } = useHits({ transformItems });

  useEffect(() => {
    if (isLoading) {
      setSearchStarted(true);
    }

    if (isIdle && searchStarted) {
      setShowSkeleton(false);
    }
  }, [isLoading, isIdle, searchStarted]);

  if (!WrappedComponent) return null;
  if (showSkeleton && skeletonSlot) return skeletonSlot;

  window.prerenderReady = true;

  return (
    <Suspense fallback={<span />}>
      <WrappedComponent showDetails={showDetails} items={items} title={title} {...props} />
    </Suspense>
  );
};

SearchResults.propTypes = {
  title: PropTypes.string,
  showDetails: PropTypes.bool,
  WrappedComponent: PropTypes.elementType,
  shouldTrackAlgoliaAnalytics: PropTypes.bool,
  skeletonSlot: PropTypes.node,
  isLoading: PropTypes.bool,
  isIdle: PropTypes.bool,
};

export default SearchResults;
